import get from 'lodash.get';

const getPartnerLoginUrl = (rootState) => get(rootState, 'partner.properties.loginUrl', null);

export default getPartnerLoginUrl;
